import React from 'react';
import { Navigate } from 'react-router-dom';

import { Paths } from '../../../shared/paths';
import { useAccess } from '../../../hooks/useAccess';
import { LanguageManagementInnerTabs } from './LanguageManagementInnerTabs';

export default function LanguageManagement() {
  const { access } = useAccess();
  const canViewSection =
    (access?.languages?.canView ?? false) ||
    (access?.translations?.canView ?? false) ||
    (access?.aiPrompts?.canView ?? false);

  if (!canViewSection) {
    return <Navigate to={Paths.root} replace />;
  }

  return <LanguageManagementInnerTabs />;
}
